import React from "react";
import MiniHero from "components/miniHero";
import ImageGallery from "components/ImageGallery";

const Massage: React.FC = () => {
  // Image paths for the ImageGallery component
  const imagePaths = [
    "/images/Massage/DSC09766-min.jpg",
    "/images/Massage/DSC09817-min.jpg",
    "/images/Massage/DSC09843-min.jpg",
    "/images/Massage/DSC09779-min.jpg",
  ];

  return (
    <div>
      {/* MiniHero Section */}
      <MiniHero image="/images/Massage/DSC09764-min.jpg" text="Massage" />

      {/* Main Content Section */}
      <div className="container mx-auto mt-16 px-8 lg:px-32 py-8 max-w-7xl">
        <div className="flex flex-col md:flex-row gap-16">
          {/* Left Column - Text Content */}
          <div className="w-full md:w-1/2">
            {/* Heading */}
            <h1
              className="text-4xl font-bold text-gray-800 mb-6"
              style={{ fontFamily: "'Bebas Neue', sans-serif" }}
            ></h1>

            {/* Introduction */}
            <p
              className="text-lg text-gray-600 mb-6"
              style={{ fontFamily: "'IBM Plex Mono', monospace" }}
            >
              Ge din kropp den omtanke den förtjänar med en avkopplande och
              återhämtande massage. Denna behandling är perfekt för att lösa upp
              spänningar i musklerna efter träning, minska stress och återställa
              din energi. Oavsett om du vill koppla av efter en lång vecka eller
              unna dig själv en stund av välbehövlig återhämtning, kommer vår
              massage att ge dig den avkoppling och välmående du behöver för att
              känna dig frisk och balanserad.
            </p>
          </div>

          {/* Right Column - ImageGallery */}
          <div className="w-full md:w-1/2">
            <ImageGallery images={imagePaths} />
          </div>
        </div>

        {/* Text under both columns */}
        <div className="my-8 mb-8">
          {/* Benefits of Massage */}
          <div className="mb-8">
            <h2
              className="text-2xl font-semibold text-gray-800 mb-4"
              style={{ fontFamily: "'Bebas Neue', sans-serif" }}
            >
              Fördelar med Massage
            </h2>
            <ul
              className="list-disc list-inside text-lg text-gray-600"
              style={{ fontFamily: "'IBM Plex Mono', monospace" }}
            >
              <li>Löser upp spänningar i musklerna.</li>
              <li>Främjar återhämtning efter träning.</li>
              <li>Hjälper till att minska stress och förbättra välmående.</li>
              <li>Ökar blodcirkulationen och flexibiliteten.</li>
              <li>En möjlighet att koppla av och hitta balans i vardagen.</li>
            </ul>
          </div>
          <h2
            className="text-2xl font-semibold text-gray-800 mb-4"
            style={{ fontFamily: "'Bebas Neue', sans-serif" }}
          >
            Anpassad för Dina Behov
          </h2>
          <p
            className="text-lg text-gray-600"
            style={{ fontFamily: "'IBM Plex Mono', monospace" }}
          >
            Våra massagebehandlingar är skräddarsydda för att möta dina
            specifika behov. Oavsett om du vill fokusera på avslappning, lindra
            muskelvärk, eller förbereda dig inför kommande träningspass, kan vi
            anpassa behandlingen för att ge dig den bästa upplevelsen.
          </p>
        </div>
      </div>
      <div
        className="text-center mb-16"
        style={{ fontFamily: "'IBM Plex Mono', monospace" }}
      >
        <a
          href="https://www.bokadirekt.se/places/lada-basteskar-60229"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-darkBlue text-white font-semibold py-3 px-8 rounded-md hover:bg-hoverBlue transition duration-200"
        >
          Boka Massage
        </a>
      </div>
    </div>
  );
};

export default Massage;
